import { Flex, Button } from '@chakra-ui/core'
import React from 'react'
import { Maybe, ProjectEntity } from '../../../generated/graphql'
import { captureEvent } from '../../../lib/analytics'
type ProjectFiltersProps = {
  projects?: Maybe<ProjectEntity>[]
  selectedProject: string | null
  setSelectedProject: React.Dispatch<React.SetStateAction<string | null>>
}

const ProjectFilters: React.FC<ProjectFiltersProps> = ({
  projects,
  selectedProject,
  setSelectedProject
}) => {
  const selectProject = (projectId: string | null) => {
    setSelectedProject(projectId)
    captureEvent('dde_project_filter_used', {
      project_id: projectId,
      cleared: !projectId,
      project_count: projects?.length || 0
    })
  }
  return (
    <Flex wrap="wrap" w="100%" py={2} mb={4} alignItems="center">
      <Button
        size="sm"
        mr={2}
        mb={2}
        fontSize="xs"
        fontWeight="normal"
        isActive={!selectedProject}
        onClick={() => selectProject(null)}
      >
        All
      </Button>
      {projects?.map((project) => (
        <Button
          key={project?.id}
          size="sm"
          mr={2}
          mb={2}
          fontSize="xs"
          fontWeight="normal"
          isActive={selectedProject === project?.id}
          onClick={() => selectProject(project?.id || null)}
        >
          {project?.attributes?.name || 'Unnamed Project'}
        </Button>
      ))}
    </Flex>
  )
}

export default ProjectFilters
